import './ConversationLogsModalPathDetails.css'
import ConversationPath from './ConversationPath/ConversationPath';
import BotService from '/src/features/editor/services/BotService';
import { useEffect, useState } from 'react';
import { useToastDispatchContext } from '/src/layouts/toast/context/toastContext';
const ConversationLogsModalPathDetails = ({ data, state }) => {

    const [blocksBot, setBlocksBot] = useState([]);
    const { getBotInformations  } = BotService
    
    const toast = useToastDispatchContext();
    const path = JSON.parse(data.logs) ? JSON.parse(data.logs).path : []

    const actionGetBotInformations = async () => {
        const [response, error] = await getBotInformations(data.bot.name);
        if(error !== null) {
            const { status } = error;
            if(status == 422) return error;
            toast.error('Error during loading', 'Cannot fetch bot data');
            return;
        }

        var { blocks } = response;
        setBlocksBot(blocks);
    }

    const getBlock = (block_id)=>{
        return blocksBot.find(b => b.object_id === block_id);
    }
    useEffect( ()=>{
        actionGetBotInformations();
    }, [])
    
    return (
        <div className="grid_container_conversation_path_fields">
            {
                blocksBot.length >0 && path.map((block_id, i) =>
                    <ConversationPath key={i} block={getBlock(block_id)} bot={data.bot}/>
                )
            }
        </div>
    );
};

export default ConversationLogsModalPathDetails;